export enum Phase {
  L1 = 1,
  L2 = 2,
  L3 = 3
}
